module.exports = __webpack_public_path__ + "img/yq.48168e4a.png";